(function (window, document) {
  'use strict';

  var state = window.ChefStopABBootstrap;
  if (!state || !state.variant) return;

  var actions = document.querySelector('[data-chefstop-concept1-actions]');
  var product = actions
    ? {
        id: actions.getAttribute('data-product-id') || '',
        handle: actions.getAttribute('data-product-handle') || '',
        title: actions.getAttribute('data-product-title') || '',
        variantId: actions.getAttribute('data-variant-id') || ''
      }
    : {};
  var quoteCompleteSent = false;
  var lastCartEvent = { key: '', at: 0 };

  function eventPayload(extra) {
    return Object.assign(
      {
        test_id: state.testId,
        variant: state.variant,
        assignment_id: state.assignmentId,
        forced: state.forced,
        product_id: product.id,
        product_handle: product.handle,
        product_title: product.title,
        variant_id: product.variantId,
        page_path: window.location.pathname
      },
      extra || {}
    );
  }

  function publish(name, extra) {
    var payload = eventPayload(extra);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var result = window.Shopify.analytics.publish('chefstop_ab:' + name, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {}

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'chefstop_ab_' + name }, payload));
    document.dispatchEvent(new CustomEvent('chefstop:ab', { detail: Object.assign({ name: name }, payload) }));
  }

  function trackQuoteCompletion(extra) {
    if (quoteCompleteSent) return;
    quoteCompleteSent = true;
    publish('quote_form_complete', Object.assign({
      form: 'zoho_product_support',
      signal: 'zoho_postmessage_submit'
    }, extra || {}));
  }

  window.ChefStopAB = {
    testId: state.testId,
    variant: state.variant,
    assignmentId: state.assignmentId,
    publish: publish,
    trackQuoteCompletion: trackQuoteCompletion
  };

  function addAttribution(form) {
    if (!form || form.getAttribute('data-chefstop-ab-ready') === 'true') return;

    var fields = {
      '_chefstop_ab_test': state.testId,
      '_chefstop_ab_variant': state.variant,
      '_chefstop_ab_assignment': state.assignmentId
    };

    Object.keys(fields).forEach(function (key) {
      var input = form.querySelector('input[name="properties[' + key + ']"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + key + ']';
        form.appendChild(input);
      }
      input.value = fields[key];
    });

    form.setAttribute('data-chefstop-ab-ready', 'true');
  }

  function attributeProductForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[action*="/cart/add"]').forEach(addAttribution);
  }

  function configureProductSupport() {
    var productInfo = document.querySelector('.l-product-info');
    var controls = productInfo && productInfo.querySelector('.l-product-controls-wrapper');
    var support = productInfo && productInfo.querySelector('.product-help-module-wrap');
    var supportBlock = support && support.closest('.l-block-liquid');
    var callbackButton = support && support.querySelector('[data-product-help-open-callback]');
    var supportCopy = support && support.querySelector('.product-help-module__copy');

    if (!support || !callbackButton || !supportCopy) return;

    var label = callbackButton.querySelector('span:last-child');
    if (label) label.textContent = 'Request Our Best Price';

    var heading = support.querySelector('.product-help-module__title');
    if (heading) heading.textContent = 'Price, stock or delivery?';

    var promise = supportCopy.querySelector('.product-help-module__promise');

    var noticeItems = productInfo.querySelectorAll('.l-prPriceInformation__item');
    noticeItems.forEach(function (item) {
      var button = item.querySelector('.l-prPriceInformation__button');
      var tooltip = item.querySelector('.l-prPriceInformation__tooltip');
      if (!button || !tooltip || button.textContent.trim() !== 'Pricing Notice') return;

      var noticeText = tooltip.textContent.replace(/\s+/g, ' ').trim();
      if (!noticeText) return;

      var noticeCopy = document.createElement('div');
      noticeCopy.className = 'chefstop-ab-notice-copy';
      noticeCopy.setAttribute('role', 'note');

      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');

      var tagShape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      tagShape.setAttribute('d', 'M3.5 11V4.5H10L20 14.5L14.5 20L4 10.5Z');
      tagShape.setAttribute('fill', 'none');
      tagShape.setAttribute('stroke', 'currentColor');
      tagShape.setAttribute('stroke-width', '1.7');
      tagShape.setAttribute('stroke-linejoin', 'round');

      var tagHole = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      tagHole.setAttribute('cx', '7.3');
      tagHole.setAttribute('cy', '7.8');
      tagHole.setAttribute('r', '1.1');
      tagHole.setAttribute('fill', 'currentColor');

      var discountMark = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      discountMark.setAttribute('d', 'm11 15 4-4m-.2.2h.01m-3.8 3.8h.01');
      discountMark.setAttribute('fill', 'none');
      discountMark.setAttribute('stroke', 'currentColor');
      discountMark.setAttribute('stroke-width', '1.5');
      discountMark.setAttribute('stroke-linecap', 'round');

      icon.appendChild(tagShape);
      icon.appendChild(tagHole);
      icon.appendChild(discountMark);

      var noticeMessage = document.createElement('strong');
      noticeMessage.textContent = 'Some manufacturers limit online prices. Ask us for our best available price.';
      noticeCopy.appendChild(icon);
      noticeCopy.appendChild(noticeMessage);
      supportCopy.insertBefore(noticeCopy, promise || null);
      item.setAttribute('data-chefstop-ab-relocated-notice', 'true');
    });

    var actionsRow = support.querySelector('.product-help-module__actions');
    if (promise && actionsRow) actionsRow.parentNode.insertBefore(promise, actionsRow.nextSibling);

    support.setAttribute('data-chefstop-ab-unified-support', 'true');
    if (state.variant === 'variant' && controls && supportBlock && controls.parentNode === supportBlock.parentNode) {
      support.setAttribute('data-chefstop-ab-moved-support', 'true');
      controls.parentNode.insertBefore(supportBlock, controls);
    }
  }

  function publishCartEvent(detail, source) {
    var response = detail && (detail.product || detail.variant);
    var variantId = response && (response.variant_id || response.id) ? String(response.variant_id || response.id) : product.variantId;
    var key = variantId + ':' + source;
    var now = Date.now();

    if (lastCartEvent.key === key && now - lastCartEvent.at < 1000) return;
    lastCartEvent = { key: key, at: now };
    publish('add_to_cart', { source: source, variant_id: variantId });
  }

  document.addEventListener('click', function (event) {
    var existingQuoteButton = event.target.closest('[data-product-help-open-callback]');
    if (existingQuoteButton && event.isTrusted) {
      publish('quote_click', {
        placement: existingQuoteButton.closest('[data-chefstop-ab-moved-support]') ? 'near_price_product_support' : 'product_help_module'
      });
      return;
    }

    var callLink = event.target.closest('a[href^="tel:"]');
    if (callLink) {
      publish('call_click', {
        placement: callLink.closest('[data-chefstop-ab-moved-support]') ? 'near_price_product_support' : 'existing_site_call',
        phone_href: callLink.getAttribute('href') || ''
      });
    }
  });

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"]')) addAttribution(event.target);
  }, true);

  document.addEventListener('product-ajax:added', function (event) {
    publishCartEvent(event.detail, 'product-ajax:added');
  });

  document.addEventListener('l:cart:updated', function (event) {
    publishCartEvent(event.detail, 'l:cart:updated');
  });

  document.addEventListener('chefstop:zoho-rfq-submitted', function (event) {
    trackQuoteCompletion(event.detail || {});
  });

  window.addEventListener('message', function (event) {
    var origin;
    var message = event.data;
    var payload = message && message.payload;

    try {
      origin = new URL(event.origin);
    } catch (error) {
      return;
    }

    if (
      origin.protocol !== 'https:' ||
      origin.hostname !== 'forms.zohopublic.com' ||
      !message ||
      message.type !== 'zf_gtm' ||
      !payload ||
      (payload.n !== 'chefstopProductRFQ' && payload.n !== 'chefstopProductContact') ||
      payload.e !== 'zf_submitform'
    ) return;

    trackQuoteCompletion({
      form: payload.n === 'chefstopProductRFQ' ? 'zoho_product_callback' : 'zoho_product_contact',
      zoho_form_alias: payload.n
    });
  }, false);

  configureProductSupport();
  attributeProductForms(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('form[action*="/cart/add"]')) addAttribution(node);
        attributeProductForms(node);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  publish('product_exposure', { placement: 'product_page' });
})(window, document);
